import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Button, ButtonType, SpecialPlanArrowIcon } from '@lean-body/components/atoms';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
import { routes } from '@lean-body/src/route';
import { useNavigate } from 'react-router-dom';
import { SettingItemKeys } from './setting_menu';
import { dateToYearMonthDayString } from '@lean-body/src/util';
export const PlanChangeUnsubscribeCpSubsection = ({ classObject, me, changePlan, apiClient, accountService, tracker, alertPresenter, basePlanId, }) => {
    const payment = me.payment;
    const currentPlan = payment.currentPlan;
    const [submitting, setSubmitting] = React.useState(false);
    const navigate = useNavigate();
    const toPerUnit = (p) => {
        if (p.isStandardPlan())
            return ' / 月';
        if (p.isThreeMonthPlan())
            return ' / 3ヶ月';
        if (p.isSixMonthPlan())
            return ' / 6ヶ月';
        if (p.isAnnualPlan())
            return ' / 年';
        return null;
    };
    const shouldShowNotice = !!changePlan.nextPlanId && !!changePlan.nextPlan;
    const onSubmit = () => {
        setSubmitting(true);
        apiClient
            .changePlanForUnsubscribeCp(basePlanId)
            .then(() => {
            accountService.reloadMe();
            tracker.trackClickPlanChange(changePlan, me);
            alertPresenter.showMessage('プラン変更に成功しました');
            navigate(`${routes.SETTING.compile()}?key=${SettingItemKeys.plan}`);
        })
            .catch((e) => {
            alertPresenter.showMessage('プラン変更に失敗しました');
            throw e;
        })
            .finally(() => {
            setSubmitting(false);
        });
    };
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement("div", { className: css(styles.head) }, "\u30D7\u30E9\u30F3\u5207\u308A\u66FF\u3048"),
        React.createElement("div", { className: css(styles.contentGroup) },
            React.createElement("div", { className: css(styles.section) },
                React.createElement("div", { className: css(styles.titleBlock) },
                    React.createElement("div", { className: css(styles.titleLead) }, "\uFF3C \u4ECA\u3060\u3051\u30FB\u3042\u306A\u305F\u3060\u3051\u306E \uFF0F"),
                    React.createElement("div", { className: css(styles.titleMain) }, "\u7279\u5225\u30D7\u30E9\u30F3\u3078\u306E\u5207\u308A\u66FF\u3048")),
                React.createElement("div", { className: css(styles.cardsGroup) },
                    React.createElement("div", { className: css(styles.currentPlanCard) },
                        React.createElement("div", { className: css(styles.currentPlanLabel) }, "\u4ECA\u307E\u3067\u306E\u30D7\u30E9\u30F3"),
                        React.createElement("div", { className: css(styles.currentPlanAmountRow) },
                            React.createElement("span", { className: css(styles.currentPlanAmount) }, currentPlan.amount.toLocaleString()),
                            React.createElement("span", { className: css(styles.currentPlanUnit) },
                                "\u5186(\u7A0E\u8FBC)",
                                toPerUnit(currentPlan)))),
                    React.createElement(SpecialPlanArrowIcon, null),
                    React.createElement("div", { className: css(styles.specialPlanCard) },
                        React.createElement("div", { className: css(styles.specialPlanDescription) },
                            "\u6B21\u56DE\u306E\u30D7\u30E9\u30F3\u66F4\u65B0\u65E5\uFF08",
                            dateToYearMonthDayString(payment.curPeriodEndDate),
                            "\uFF09\u304B\u3089",
                            React.createElement("br", null),
                            "\u7279\u5225\u30D7\u30E9\u30F3\u306B\u5207\u308A\u66FF\u3048"),
                        React.createElement("div", { className: css(styles.specialPlanInner) },
                            React.createElement("div", { className: css(styles.goldBadge) },
                                "\u7279\u5225\u30D7\u30E9\u30F3 (",
                                changePlan.periodInMonths,
                                "\u30F6\u6708)"),
                            React.createElement("div", { className: css(styles.priceRow) },
                                React.createElement("span", { className: css(styles.priceNumber) }, changePlan.amountPerMonth.toLocaleString()),
                                React.createElement("span", { className: css(styles.priceUnit) }, "\u5186 / \u6708")),
                            React.createElement("div", { className: css(styles.periodTotal) },
                                changePlan.periodInMonths,
                                "\u30F6\u6708\u3067",
                                changePlan.amount.toLocaleString(),
                                "\u5186(\u7A0E\u8FBC)"))))),
            React.createElement(Button, { className: css(styles.submitButton), buttonType: ButtonType.pink, onClick: onSubmit, loading: submitting, disabled: submitting, dataTest: "submitChangePlan", fullWidth: true }, "\u30D7\u30E9\u30F3\u3092\u5207\u308A\u66FF\u3048\u308B"),
            shouldShowNotice && (React.createElement("div", { className: css(styles.noticeContainer) },
                React.createElement("div", { className: css(styles.noticeTitle) }, "\u6CE8\u610F\u4E8B\u9805"),
                React.createElement("div", { className: css(styles.noticeText) },
                    "\u203B",
                    changePlan.periodInMonths,
                    "\u30F6\u6708\u5F8C\u306B\u81EA\u52D5\u7684\u306B",
                    changePlan.nextPlan.name,
                    "\uFF08",
                    changePlan.nextPlan.isAnnualPlan() && '年間',
                    changePlan.nextPlan.amountWithoutTax.toLocaleString(),
                    "\u5186\u30FB\u7A0E\u8FBC",
                    changePlan.nextPlan.amount.toLocaleString(),
                    "\u5186\uFF09\u3078\u5207\u308A\u66FF\u308F\u308A\u307E\u3059\u3002",
                    React.createElement("br", null),
                    "\u203B\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u7D42\u4E86\u5F8C\u306E\u7D99\u7D9A\u3092\u5E0C\u671B\u3055\u308C\u306A\u3044\u5834\u5408\u306F\u3001",
                    changePlan.periodInMonths,
                    "\u30F6\u6708\u4EE5\u5185\u306B\u8A2D\u5B9A\u304B\u3089\u304A\u624B\u7D9A\u304D\u304F\u3060\u3055\u3044\u3002",
                    React.createElement("br", null),
                    "\u203B\u30E1\u30AC\u30ED\u30B9\u30D7\u30E9\u30F3\u306E\u65B9\u306F\u3001\u5207\u308A\u66FF\u3048\u5F8C\u30E1\u30AC\u30ED\u30B9\u9650\u5B9ALIVE\u304C\u8996\u8074\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002"))))));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
    },
    head: {
        width: '100%',
        padding: '40px 0 24px',
        fontSize: 18,
        fontWeight: 'bold',
        lineHeight: 1.4,
        letterSpacing: 1.44,
        color: Colors.TextDark,
        textAlign: 'left',
    },
    contentGroup: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 40,
        width: '100%',
        [MediaBreakPointUp.MD]: {
            maxWidth: 333,
        },
    },
    section: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 24,
        paddingTop: 24,
        width: '100%',
    },
    titleBlock: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        width: '100%',
        textAlign: 'center',
        color: Colors.Accent,
        fontWeight: 'bold',
    },
    titleLead: {
        fontSize: 16,
        lineHeight: 1,
    },
    titleMain: {
        fontSize: 25,
        lineHeight: 1,
    },
    cardsGroup: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
        width: '100%',
    },
    currentPlanCard: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 4,
        width: '100%',
        padding: '8px 24px 16px',
        borderRadius: 10,
        border: `1px solid ${Colors.GrayDarkest}`,
        backgroundColor: Colors.White,
        color: Colors.GrayDarkest,
        whiteSpace: 'nowrap',
    },
    currentPlanLabel: {
        fontSize: 12,
        lineHeight: 1.6,
        letterSpacing: 0.48,
    },
    currentPlanAmountRow: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        gap: 4,
    },
    currentPlanAmount: {
        fontSize: 18,
        fontWeight: 500,
        lineHeight: 1,
        textDecoration: 'line-through',
    },
    currentPlanUnit: {
        fontSize: 12,
        lineHeight: 1,
    },
    specialPlanCard: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 12,
        width: '100%',
        padding: '16px 24px',
        borderRadius: 10,
        border: `3px solid ${Colors.Accent}`,
        backgroundColor: Colors.White,
        filter: 'drop-shadow(0 0 5px rgba(132, 39, 78, 0.3))',
    },
    specialPlanDescription: {
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1.6,
        letterSpacing: 0.48,
        color: Colors.Black,
        textAlign: 'center',
    },
    specialPlanInner: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 12,
    },
    goldBadge: {
        padding: '4px 10px',
        borderRadius: 10,
        fontSize: 14,
        fontWeight: 'bold',
        lineHeight: 1,
        letterSpacing: 0.56,
        color: Colors.White,
        textShadow: '0 0 4px #A78334',
        whiteSpace: 'nowrap',
        background: 'linear-gradient(0deg, rgb(197, 173, 109) 0%, rgb(175, 139, 58) 16%, rgb(241, 221, 128) 54%, rgb(241, 221, 128) 75%, rgb(191, 158, 64) 93%, rgb(244, 216, 138) 107%)',
    },
    priceRow: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        gap: 5,
        color: Colors.Accent,
    },
    priceNumber: {
        fontFamily: 'Gotham SSm B',
        fontSize: 52,
        fontWeight: 'bold',
        lineHeight: 1,
    },
    priceUnit: {
        fontSize: 14,
        fontWeight: 'bold',
        lineHeight: 1,
        letterSpacing: 0.56,
    },
    periodTotal: {
        fontSize: 14,
        fontWeight: 'bold',
        lineHeight: 1.4,
        letterSpacing: 0.56,
        color: Colors.Black,
        whiteSpace: 'nowrap',
    },
    submitButton: {
        width: '100%',
        height: 60,
        borderRadius: 30,
        fontSize: 20,
        letterSpacing: 1.6,
    },
    noticeContainer: {
        width: '100%',
        textAlign: 'left',
    },
    noticeTitle: {
        fontSize: 10,
        fontWeight: 400,
        lineHeight: 1.4,
        letterSpacing: 0.5,
        color: Colors.StrictBlack,
    },
    noticeText: {
        fontSize: 10,
        fontWeight: 400,
        lineHeight: 1.4,
        letterSpacing: 0.5,
        color: Colors.StrictBlack,
    },
});
